module.exports = __webpack_public_path__ + "static/media/banner.4a2a3cce.jpg";